import _ from "lodash";

import EN from "../assets/localization/en.json";
import FR from "../assets/localization/fr.json";
import DE from "../assets/localization/de.json";


// class definition
export class Localization {

    constructor() {

        this._locale = null;
        this._resources = null;
    }

    get locale() {
        return this._locale;
    }

    set locale(locale) {
        this._locale = locale;

        // swap to correct resource
        switch (this._locale) {
            case "fr":
                this._resources = FR;
                break;
            case "de":
                this._resources = DE;
                break;
            default:
                this._resources = EN;
                break;
        }
    }

    get resources() {
        return this._resources;
    }

    get(path, ...parameters) {

        // get raw value
        let value = _.get(this._resources, path, "");

        // format value
        value = value.replace(/{(\d+)}/g, (match, number) => {

            // get argument parameter
            const parameter = parameters[number];

            // return replacement (or fallback to original
            return _.isUndefined(parameter)
                ? match
                : parameter;
        });

        // return final value
        return value;
    }
}


// WEBPACK FOOTER //
// ./src/services/Localization.js